export const CHANGE_REGION = 'CHANGE_REGION';
export const UPDATE_DATA = 'UPDATE_DATA';

export function incrementYear() {
    return {type: "YEAR_INCREMENT"};
}

export function decrementYear() {
	return {type: "YEAR_DECREMENT"};
}


// WEBPACK FOOTER //
// ./src/actions/index.js